import { jsx as e } from "react/jsx-runtime";
import { useState as o, useEffect as a } from "react";
import { parse as t } from "date-fns";
import r from "dayjs";
import { ISO_DATE_FORMAT as i, formatDate as n } from "../../utils/formatDate.js";
import { KendoDatePicker as l } from "../KendoDatePicker/index.js";
import { FormField as d } from "../FormField.js";
r.locale("uk");
const s = ({ autoFocus: s2, format: m, control: u, name: c, label: f, onChange: v, required: p, preview: D, disabled: F, defaultValue: w, loading: g = false, views: j, minDate: y, maxDate: b }) => {
  const [h, x] = o(false);
  a(() => {
    w && u.setFieldValue(c, w.format(i));
  }, []);
  const B = (e2) => {
    if (e2) {
      const o2 = t(e2.replace(/T.*$/, ""), "yyyy-MM-dd", /* @__PURE__ */ new Date());
      return "Invalid Date" === o2.toString() ? void 0 : o2;
    }
    return null;
  }, C = () => x(true), I = () => x(false);
  return e(d, { control: u, label: f, name: c, required: p, preview: D, renderPreview: ({ value: e2 }) => n(e2), loading: g, disabled: F, hideErrorMessageFn: (e2) => Boolean(h && !e2), children: ({ name: o2, value: a2, isInvalid: t2, fieldRef: i2 }) => e(l, { autoFocus: s2, format: m, minDate: y ? r(y).toDate() : void 0, maxDate: b ? r(b).toDate() : void 0, views: j, name: o2, isInvalid: t2, value: B(a2), onOpen: C, onFocus: C, onClose: I, onBlur: I, onChange: async (e2) => {
    const a3 = (e2 == null ? void 0 : e2.toLocaleDateString("en-GB").split("/").toReversed().join("-")) || "";
    v ? v(a3) : (await u.setFieldValue(o2, a3), await u.setFieldTouched(o2, true));
  }, disabled: F, inputRef: i2 }) });
};
export {
  s as KendoDatePickerField
};
//# sourceMappingURL=KendoDatePickerField.js.map
